// extracted by mini-css-extract-plugin
module.exports = {"red":"#e31818","backgroundGrey":"#EAEAEA","lightGrey":"#D5D5D5","grey":"#868686","darkGrey":"#585856","bordeaux":"#821423","blue":"#34A2CD","mint":"#57B695","small":"500","map":"src-components-Map--map","stationsDropdown":"src-components-Map--stationsDropdown","dayYearSelectorWrapper":"src-components-Map--dayYearSelectorWrapper","dayYearSelector":"src-components-Map--dayYearSelector","selectorContent":"src-components-Map--selectorContent"};
    if(module.hot) {
      // 1590940330849
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  